/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for creating workshop attendance.
 * @export
 * @interface WorkshopAttendanceCreate
 */
export interface WorkshopAttendanceCreate {
    /**
     * 
     * @type {string}
     * @memberof WorkshopAttendanceCreate
     */
    user_id: string;
}

/**
 * Check if a given object implements the WorkshopAttendanceCreate interface.
 */
export function instanceOfWorkshopAttendanceCreate(value: object): value is WorkshopAttendanceCreate {
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    return true;
}

export function WorkshopAttendanceCreateFromJSON(json: any): WorkshopAttendanceCreate {
    return WorkshopAttendanceCreateFromJSONTyped(json, false);
}

export function WorkshopAttendanceCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopAttendanceCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
    };
}

export function WorkshopAttendanceCreateToJSON(json: any): WorkshopAttendanceCreate {
    return WorkshopAttendanceCreateToJSONTyped(json, false);
}

export function WorkshopAttendanceCreateToJSONTyped(value?: WorkshopAttendanceCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['user_id'],
    };
}

